import React from "react";

interface WithFilterFormFieldProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

// withFilterFormField HOC
const withFilterFormField = <P extends object>(
  WrappedComponent: React.FC<P>
) => {
  const EnhancedComponent = (props: P & WithFilterFormFieldProps) => {
    return <WrappedComponent {...props} />;
  };

  EnhancedComponent.displayName = `withFilterFormField(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  return EnhancedComponent;
};

export default withFilterFormField;
